export default __webpack_public_path__ + "static/media/slider3.b26994dc.svg";